import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { type LWApiPublicProjectCategoriesResultRawI } from '@liquidweb-dev/club-sauce/public/project/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const PROJECT_CATEGORIES_QUERY_KEY = '/project/categories';

const useProjectCategories = (
	options?: UseQueryOptions<LWApiPublicProjectCategoriesResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [PROJECT_CATEGORIES_QUERY_KEY],
		queryFn: () => api.project.apiRaw.categories(),
		...options,
	});

export default useProjectCategories;
